<!--
  //nuxt-ui/components/base/BaseModal.vue
  -->

<script setup lang="ts">
import { useSlots } from "vue";
import AlertIcon from "~/nuxt-ui/components/Shared/icons/AlertIcon.vue";

type Props = {
  modelValue: boolean;
  modalId: string;
  message?: string;
  showCloseButton?: boolean;
  isAlert?: boolean;
  isPreview?: boolean;
};

const slots = useSlots();
const props = defineProps<Props>();
const emits = defineEmits(["update:modelValue"]);

const closeModal = () => {
  emits("update:modelValue", false);
};
</script>

<template>
  <div
    :id="modalId"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    v-if="modelValue"
    @click="closeModal"
  >
    <div
      class="relative shadow-lg rounded-lg w-80"
      :class="isPreview ? 'bg-black' : 'bg-gray-900 '"
      @click.stop
    >
      <div
        v-if="isAlert"
        class="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center w-12 h-12 rounded-full bg-red-600 text-white text-xl font-bold"
      >
        <AlertIcon />
      </div>
      <div class="flex items-center justify-between px-2">
        <div class="flex-grow">
          <slot name="header"></slot>
        </div>
        <button v-if="showCloseButton" class="text-xl font-bold cursor-pointer" @click="closeModal">x</button>
      </div>

      <div :class="['p-4', { 'text-center': isAlert }]">
        <slot name="body"> {{ message }} </slot>
      </div>

      <template v-if="!!slots.footer">
        <div class="p-2">
          <slot name="footer"></slot>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped></style>
